interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-background-100 text-foreground-400">
        <i className={`${icon} text-2xl`} />
      </div>
      <h3 className="mt-4 font-heading text-[15px] font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-600"
        >
          <i className="ri-add-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}